import { render, staticRenderFns } from "./TextQuestion.vue?vue&type=template&id=4cd5f885&scoped=true&"
import script from "./TextQuestion.vue?vue&type=script&lang=ts&"
export * from "./TextQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./TextQuestion.vue?vue&type=style&index=0&id=4cd5f885&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd5f885",
  null
  
)

export default component.exports